module.exports = __webpack_public_path__ + "static/media/Reembolsos.0bd29804.png";